






















import LinkExternal from '@/components/common/LinkExternal.vue'
import { isLinkExternal } from '@/utils/common.utils'
import { defineComponent, PropType } from '@vue/composition-api'
import RichTextContainer from '@/components/rich-text-container/RichTextContainer.vue'
import { TcButton } from '@telia/shared-ui-components'
import { RoutePath as routes } from '@/router'
import { CfAnslButton } from '@/types/ansl-space/types/cf-ansl-button'

export default defineComponent({
  components: {
    RichTextContainer,
    LinkExternal,
    TcButton
  },
  props: {
    links: {
      type: Array as PropType<Array<CfAnslButton>>,
      required: true
    }
  },
  setup () {
    return {
      routes,
      isLinkExternal
    }
  }
})

